<script setup>
import { useI18n } from 'vue-i18n'
import RemoteSigningLayout from '@/Layouts/RemoteSigningLayout.vue'
defineOptions({ layout: RemoteSigningLayout })
const { t } = useI18n()
</script>

<template>
  <section class="rounded-[var(--radius-lg)] border border-[color:var(--line)] bg-[color:var(--surface)] p-6 text-center">
    <div class="mx-auto mb-4 w-12 h-12 rounded-full flex items-center justify-center"
         style="background-color: var(--okSoft); color: var(--ok);">
      <svg viewBox="0 0 24 24" fill="none" class="w-7 h-7">
        <path d="M5 12.5L10 17.5L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <h1 class="font-display text-xl text-[color:var(--ink)]">{{ t('remoteSigning.done.title') }}</h1>
    <p class="text-sm text-[color:var(--inkSoft)] mt-2">{{ t('remoteSigning.done.body') }}</p>
  </section>
</template>
